import React from 'react';
import { Link } from 'react-router';
import type { LscArchiveItem } from '../../types';
import { lscPath } from '../../routing';
import ArchiveReplayCard from './ArchiveReplayCard';
import EmptyState from '../EmptyState';

export type RecentArchivesSectionProps = {
  leagueId: string;
  archives: LscArchiveItem[];
  loading?: boolean;
  error?: string | null;
  limit?: number;
  onSelectArchive?: (archive: LscArchiveItem) => void;
};

const RecentArchivesSection: React.FC<RecentArchivesSectionProps> = ({
  leagueId,
  archives,
  loading = false,
  error = null,
  limit = 8,
  onSelectArchive,
}) => {
  const items = archives.slice(0, limit);

  return (
    <section className="space-y-4" data-testid="recent-archives-section">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-white">Recently Archived</h2>
          <p className="text-sm text-secondary-400 mt-1">Published replays from league streams.</p>
        </div>
        <Link
          to={lscPath(`/leagues/${leagueId}/archive`)}
          className="text-sm text-primary-300 hover:text-primary-200 shrink-0"
        >
          View archive
        </Link>
      </div>

      {loading ? (
        <p className="text-sm text-secondary-400">Loading replays...</p>
      ) : error ? (
        <p className="text-sm text-red-300">{error}</p>
      ) : items.length === 0 ? (
        <EmptyState
          title="No replays yet"
          message="Published streams will appear here after commissioners archive verified VODs."
        />
      ) : (
        <div
          className="flex gap-4 overflow-x-auto pb-2"
          data-testid="recent-archives-row"
        >
          {items.map((archive) => (
            <ArchiveReplayCard
              key={archive.id}
              leagueId={leagueId}
              archive={archive}
              onSelect={onSelectArchive}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default RecentArchivesSection;
